export default __webpack_public_path__ + "static/media/Cost-benefit analysis impacts.f9a87e76.pdf";